import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Store } from '@ngrx/store';
import { finalize } from 'rxjs/operators';

import { SpinnerService } from 'src/app/shared/spinner/spinner.service';

import { SiteService } from '../../../core/api/site.service';
import { FileService } from '../../../core/helper/file.service';
import { StatusEnum } from '../../../shared/constants/site_status.enum';
import { DialogYesNoComponent } from '../../../shared/dialogs/dialog-yes-no/dialog-yes-no.component';
import { Site } from '../../../shared/models';
import * as fromApp from '../../../store';

@Component({
  selector: 'fc-site-approval-step-2',
  templateUrl: './site-approval-step-2.component.html',
  styleUrls: ['./site-approval-step-2.component.scss'],
})
export class SiteApprovalStep2Component implements OnInit {
  @ViewChild('matExpansionPanel', { static: false })
  matExpansionPanel: MatExpansionPanel;

  @Input()
  site: Site;

  @Input()
  isAdmin = false;

  @Input()
  expanded = false;

  @Output()
  doChangeSiteState: EventEmitter<StatusEnum> = new EventEmitter<StatusEnum>();

  transmissionOption: string;
  options: any[] = null;

  emailAddress = 'email';

  errorDetail: string = null;

  constructor(
    public dialog: MatDialog,
    readonly siteService: SiteService,
    readonly fileService: FileService,
    readonly store: Store<fromApp.AppState>,
    readonly spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    // check that the value is an email address to prevent script insertion when
    // this value is passed the "innerHtml" of the span
    this.emailAddress = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      this.site.account.user.email
    )
      ? this.site.account.user.email
      : 'unknown';
    this.options = [
      { value: 'docusign', text: 'Send contract via DocuSign' },
      {
        value: 'manual',
        text: `Sent manually to <a href="mailto:${this.emailAddress}">${this.emailAddress}`,
      },
    ];
  }

  sendContract() {
    this.dialog
      .open(DialogYesNoComponent, {
        panelClass: 'fc-yes-no-dialog',
        data: {
          title: 'Please Confirm',
          line1: 'This will update the site status. Are you sure you want to continue?',
          line2: '',
          buttonTextYes: 'Yes, Continue',
          buttonTextNo: 'No, Cancel',
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          if (this.transmissionOption === 'docusign') {
            this.spinnerService.show('app-spinner');
            this.siteService
              .sendContract(this.site.identifier)
              .pipe(finalize(() => this.spinnerService.hide('app-spinner')))
              .subscribe(
                () => {
                  this.doChangeSiteState.emit(StatusEnum.CONTRACT_SENT);
                },
                (err: HttpErrorResponse) => (this.errorDetail = `Can't send contract: ${err.error.detail}`),
                () => {}
              );
          } else {
            this.doChangeSiteState.emit(StatusEnum.CONTRACT_SENT);
          }
        }
      });
  }

  downloadContract($event: any): void {
    $event.stopPropagation();

    this.siteService.downloadContract(this.site.identifier).subscribe(bytes => {
      const blob = this.fileService.getBlobFromBytes(bytes);

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Site_ID_' + this.site.id + '_Enrollment_Agreement.docx';
      link.click();
    });
  }

  get isCurrentStep() {
    return this.site.status === StatusEnum.APPROVED || this.site.status === StatusEnum.APPROVED_CONDITIONALLY;
  }

  get stepComplete() {
    return (
      this.site.approvedDate !== null &&
      this.site.status !== StatusEnum.APPROVED &&
      this.site.status !== StatusEnum.APPROVED_CONDITIONALLY
    );
  }

  protected readonly StatusEnum = StatusEnum;
}
